<template>
  <div class="address-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="地址管理" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="address-info default-top-bg">
      <div class="default-address" v-if="defaultAddress.id">
        <div class="default-address-detail" @click="editAddress(defaultAddress.id)">
          <!-- <img src="../../assets/icon/icon-address.png"> -->
          <div class="address-detail">{{defaultAddress.receiver}}</div>
          <div class="address-detail-phone">{{defaultAddress.phone}}</div>
          <div class="edit-btn"><img src="../../assets/icon/icon-evaluate-edit-btn.png"></div>
        </div>
        <div class="default-address-down">
           <div class="default-btn"><span>默认</span></div>
          <div class="address-content">{{defaultAddress.address}}</div>
        </div>
      </div>
    </div>
    <div class="address-list" v-for="address in addressList" @click="editAddress(address.id)">
       <div class="address-detail-up">
         <div class="detail-address">{{address.receiver}}</div>
         <div class="detail-address" style="flex-grow: 1;margin-left:0.2rem;margin-top:0.08rem;color:rgb(156,156,156);font-size:0.3rem;">{{address.phone}}</div>
         <div class="list-edit-btn">编辑</div>
       </div>
       <div class="address-detail-down">
         <div class="address-content" style="color:rgb(156,156,156);font-size:0.3rem;">{{address.address}}</div>
       </div>
     </div>
    <div class="add-new-address" @click="editAddress('')">添加新地址</div>
    <div v-if="delAddressModal" class="toast refuse-modal">
      <div class="refuse-modal-title">删除收货地址确认</div>
      <div class="refuse-modal-text">确认要删除该收货地址吗？</div>
      <div class="confirm-footer" >
        <div class="cancel-btn" @click = "cancelRemove">取消</div>
        <div class="agree-btn" @click="confirmRemove">删除</div>
      </div>
    </div>
    <div v-if="delAddressModal" class="general-box-bg"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import customerAddressService from '../../service/customer/CustomerAddressService'

  export default {
    name: 'AddressList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        addressList:[],
        operationAddressId:'',
        delAddressModal:false,
        isWechatBrowser:this.$verfyBrowserType(),
        defaultAddress:{},
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getAddressList();
    },
    methods: {
      async getAddressList(){
        let {code,msg,data} = await customerAddressService.list();
        if(code == '0'){
          this.addressList = data;
          for (let address of this.addressList) {
            if(address.isDefault == 1){
              this.defaultAddress = address;
            }
          }
        }else {
          Toast(msg);
        }
      },
      editAddress(id){
        if(this.global.isMiniProgrm){
          const h5Url = `/mine/address/edit?addressId=${id}`
          wx.miniProgram.navigateTo({
            url: `/pages/h5/webview/index?path=${encodeURIComponent(h5Url)}&nbBackgroundColor=#ffffff&addressId=${id}&nbFrontColor=#000000`,
          })
        }else{
          this.$router.push({name:'AddressEdit',query:{addressId:id}});
        }

      },
      async installDefault(id){
        let result = await customerAddressService.setDefault(id);
        if(result.code == '0'){
          Toast(result.msg);
          this.getAddressList();
        }else {
          Toast(result.msg);
        }
      },
      preRemoveBankCard(id){
        this.operationAddressId = id;
        this.delAddressModal = true;
      },
      cancelRemove(){
        this.delAddressModal = false;
      },
      async confirmRemove(){
        let result = await customerAddressService.delete(this.operationAddressId);
        if(result.code == '0'){
          this.delAddressModal = false;
          Toast('地址删除操作成功!');
          this.getAddressList();
        }else {
          Toast(result.msg);
        }
      },
      async cancelDefault(id){
        let result = await customerAddressService.setDefault(id);
        if(result.code == '0'){
          Toast('取消默认地址操作成功!');
          this.getAddressList();
        }else {
          Toast(result.msg);
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  .address-list-page{
    background: white;
    height: 100vh;
  }
  .address-info{
    color: #1b1e29;
    padding: 0 0.3rem;
    margin-bottom:  0.24rem;
    font-size: 0.28rem;
  }
  .address-list{
    border-bottom: 1px solid rgba(0,0,0,0.1);
    width: 6.90rem;
    height: 1.46rem;
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
    padding-left: 0.2rem;
    .address-detail-up{
      display: flex;
      padding-top: 0.2rem;
      .detail-address{
         font-size: 0.36rem;
      }
    }
     .address-detail-down{
       margin-top: 0.02rem;
        font-size: 0.28rem;
        color: #7f7d7c;
        .address-content{
          color: #7f7d7c;
        }
      }
    .list-edit-btn{
      width: 0.8rem;
      margin-top: 0.08rem;
      margin-right: 0.25rem;
      // border-radius: 0.2rem;
      // background-color:#fce8be;
      font-size: 0.24rem;
      color: rgb(8,75,144);
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      border-left: 2px solid #999999;
    }
  }
  .default-address{
    .default-address-detail{
      padding-left: 0.3rem;
      display: flex;
      padding-top: 0.3rem;
      padding-bottom: 0.1rem;
      .address-detail-phone{
        margin-left: 0.1rem;
        font-size: 0.26rem;
        margin-top: 0.3rem;
        color: white;
      }
      // .edit-btn{
      //   margin-left: 0.1rem;
      // }
    }
    .default-address-down{
      display: flex;
      align-items: center;
    }
    .default-btn{
      width: 0.58rem;
      height: 0.32rem;
      margin-left: 0.47rem;
      margin-right: 0.1rem;
      background-color: white;
      border-radius: 15px;
      font-size: 0.22rem;
      color: #d54a33;
      line-height: 0.3rem;
    }
    .default-btn span{
      margin-left: 0.09rem;
    }
    .default-address-detail img{
        width: 0.35rem;
	      height: 0.42rem;
        margin-top: 0.04rem;
      }
    .edit-btn{
      width: 0.8rem;
      height: 0.4rem;
      margin-left: 0.1rem;
      margin-top: 0.13rem;
      // border-radius: 0.2rem;
      // background-color: white;
      // font-size: 0.24rem;
      // color: #feac00;
      // line-height: 0.45rem;
      text-align: center;
      img{
        width: 0.37rem;
        height: 0.37rem;
      }
    }
    .address-detail{
      margin-left: 0.2rem;
      font-size: 0.35rem;
      color: white;
      padding-top: 0.2rem;
    }
    .default-address-detail-up{
      margin-left: 0.15rem;
      margin-right: 0.25rem;
    }
  }
  .address-content{
    text-align: left;
    color: #5f3b1d;
    font-size: 0.26rem;
  }
  .operation-part{
    color: #878e99;
    display: flex;
    justify-content: space-between;
    line-height: 1rem;
    .right{
      display: flex;
    }
  }
  .set-default{
    margin-right: 2rem;
    display: flex;
  }
  .edit-bank-card{
    display: flex;
    margin-right: 0.32rem
  }
  .del-bank-card{
    display: flex
  }
  .icon-set-default{
    width: 0.37rem;
    height: 0.38rem;
  }
  .icon-card-edit{
    width: 0.34rem;
    height: 0.35rem;
  }
  .card-operation{
    margin-top: 0.4rem
  }
  .add-new-address{
    position: fixed;
    bottom: 0.5rem;
    left:0;
    right:0;
    margin: 0 auto;
    width: 90%;
    height: 0.91rem;
    border-radius: 0.1rem;
    // margin: 6.5rem 0.3rem 0 0.3rem;
    text-align: center;
    background-color: rgb(0,71,142);
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.85rem;
    letter-spacing: 0.05rem;
  }
</style>
